import React, { useEffect, useState, useRef } from "react";
import { Col, Spin, Row } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { runCalculations, getCalculationsResults, fetchCasperRecords } from "../../features/RawData/RawDataSlice";
import { AnnualVesselAnalysis } from "../../features/CasperAnalysis/CasperAnalysisSlice";


const VoyageData = ({ selectedOption, record }) => {
  const dispatch = useDispatch();
  const { calculationsStatus, calculationsResult, globalFilters, casperOutputData } = useSelector((state) => state.rawData);
  const [isResultSynced, setIsResultSynced] = useState(casperOutputData[record?.casper_id]?.is_result_synced);
  const rerunApiFlag = useRef(false);
  const [loading, setLoading] = useState(false);
  const calculationsPayload = {
    casper_id: record?.casper_id,
  };
  useEffect(() => {
    setIsResultSynced(casperOutputData[record?.casper_id]?.is_result_synced);
  }, [casperOutputData, record?.casper_id]);

  const handleRerunClick = async () => {
    setLoading(true);
    await dispatch(runCalculations(calculationsPayload));
    await dispatch(getCalculationsResults(record?.casper_id)).then((result) => {
      dispatch(fetchCasperRecords({ ...globalFilters, requestedTab: "casper_output", casperID: record?.casper_id || "" }))

      dispatch(AnnualVesselAnalysis({ iMONumber: record?.imo_number, voyageYear: globalFilters?.year }));

    })
    if (calculationsStatus !== "failed") {
      rerunApiFlag.current = true;
    } else {
      console.error("API call failed");
    }
  };

  useEffect(() => {
    if (calculationsResult?.is_result_synced && calculationsStatus === "succeeded") {
      setLoading(false);
    }
  }, [calculationsResult?.is_result_synced, calculationsStatus]);


  return (
    <div className="voyage-data-container">
      {selectedOption === "Fuel Consumption" ? (
        <div className="voyage-data-multi" style={{ width: "25vw" }}>
          <div style={{ marginLeft: "-20px" }}>Standard Fuels (MT)</div>
          <Row
            style={{ marginLeft: "-19px" }}
            gutter={{
              xs: 8,
              sm: 16,
              md: 24,
              lg: 32,
            }}
          >
            {record?.fuel_details.map((fuel, index) => (
              <Col
                key={index}
                className="gutter-row"
                style={{ marginTop: "12px" }}
                span={6}
              >
                <div
                  className="voyage-data-header"
                  style={{
                    background: "white",
                    marginLeft: "-1rem",
                    fontSize: "10.5px",
                    fontWeight: "400",
                    lineHeight: "11.4px",
                  }}
                >
                  {fuel.name}
                </div>
                <div
                  className="voyage-data-content"
                  style={{ background: "white" }}
                >
                  {`${fuel?.total_fuel == 0 ? 0 : fuel?.total_fuel?.toFixed(3)}`}
                </div>
              </Col>
            ))}
          </Row>
        </div>
      ) : (
        <div
          className="voyage-data-multi"
          style={{ width: "100%", position: "relative" }}
        >
          {loading ? (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Spin tip="Loading..." />
            </div>
          ) : isResultSynced === false ? (
            <>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "1rem", marginTop: "3rem", }}>
                <p>
                  Your casper results are not synced. Please rerun calculations.
                </p>
                <div onClick={handleRerunClick} className="reset-btn">
                  Rerun Calculation
                </div>
              </div>
            </>
          ) : (
            <Row
              style={{
                marginLeft: "-13px",
                lineHeight: "15.4px",
                marginBottom: "12px",
              }}
              gutter={{
                xs: 8,
                sm: 16,
                md: 24,
                lg: 32,
              }}
            >
              <Col
                className="gutter-row"
                style={{ marginTop: "12px" }}
                span={6}
              >
                <>
                  <div
                    className="voyage-data-header"
                    style={{
                      background: "white",
                      marginLeft: "-1rem",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "16px",
                    }}
                  >
                    CO₂ eq
                  </div>
                  <div
                    className="voyage-data-content"
                    style={{ background: "white", marginLeft: "-1rem" }}
                  >
                    {casperOutputData[record?.casper_id]?.co2eq_emissions || casperOutputData[record?.casper_id]?.co2eq_emissions == 0 ? casperOutputData[record?.casper_id].co2eq_emissions.toFixed(3) : '-'} MT
                  </div>
                </>
              </Col>
              <Col
                className="gutter-row"
                style={{ marginTop: "12px" }}
                span={6}
              >
                <>
                  <div
                    className="voyage-data-header"
                    style={{
                      background: "white",
                      marginLeft: "-1rem",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "16px",
                    }}
                  >
                    EEOI
                  </div>
                  <div
                    className="voyage-data-content"
                    style={{ background: "white", marginLeft: "-1rem" }}
                  >
                    {casperOutputData[record?.casper_id]?.eeoi ? casperOutputData[record?.casper_id]?.eeoi?.toFixed(3) : '-'} gCO₂/Tonne-nm
                  </div>
                </>
              </Col>
              <Col
                className="gutter-row"
                style={{ marginTop: "12px" }}
                span={6}
              >
                <>
                  <div
                    className="voyage-data-header"
                    style={{
                      background: "white",
                      marginLeft: "-1rem",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "16px",
                    }}
                  >
                    CO₂ eq ETS
                  </div>
                  <div
                    className="voyage-data-content"
                    style={{ background: "white", marginLeft: "-1rem" }}
                  >
                    {casperOutputData[record?.casper_id]?.co2eq_emissions_ets || casperOutputData[record?.casper_id]?.co2eq_emissions_ets == 0 ? casperOutputData[record?.casper_id]?.co2eq_emissions_ets.toFixed(3) : '-'} MT
                  </div>
                </>
              </Col>
              <Col
                className="gutter-row"
                style={{ marginTop: "12px" }}
                span={6}
              >
                <>
                  <div
                    className="voyage-data-header"
                    style={{
                      background: "white",
                      marginLeft: "-1rem",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "16px",
                    }}
                  >
                    Identifier
                  </div>
                  <div
                    className="voyage-data-content"
                    style={{ background: "white", marginLeft: "-1rem" }}
                  >
                    {casperOutputData[record?.casper_id]?.identifier ? casperOutputData[record?.casper_id]?.identifier : '-'}
                  </div>
                </>
              </Col>
              <Col
                className="gutter-row"
                style={{ marginTop: "12px" }}
                span={6}
              >
                <>
                  <div
                    className="voyage-data-header"
                    style={{
                      background: "white",
                      marginLeft: "-1rem",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "16px",
                    }}
                  >
                    AER Ratio
                  </div>
                  <div
                    className="voyage-data-content"
                    style={{ background: "white", marginLeft: "-1rem" }}
                  >
                    {casperOutputData[record?.casper_id]?.cii || casperOutputData[record?.casper_id]?.cii == 0 ? casperOutputData[record?.casper_id]?.cii.toFixed(3) : '-'}
                  </div>
                </>
              </Col>
              <Col
                className="gutter-row"
                style={{ marginTop: "12px" }}
                span={6}
              >
                <>
                  <div
                    className="voyage-data-header"
                    style={{
                      background: "white",
                      marginLeft: "-1rem",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "16px",
                    }}
                  >
                    CII
                  </div>
                  <div 
                    className="voyage-data-content voyage-data-grade-CII"
                    style={{
                      background: casperOutputData[record?.casper_id]?.technical_grade === 'A'
                        ? 'rgb(113, 189, 126)'
                        : casperOutputData[record?.casper_id]?.technical_grade === 'B'
                          ? 'rgb(214, 233, 201)'
                          : casperOutputData[record?.casper_id]?.technical_grade === 'C'
                            ? 'rgb(249, 226, 143)'
                            : casperOutputData[record?.casper_id]?.technical_grade === 'D'
                              ? 'rgb(251, 212, 193)'
                              : casperOutputData[record?.casper_id]?.technical_grade === 'E'
                                ? 'rgb(255, 133, 133)'
                                : 'white',
                      marginLeft: "-1rem",
                      padding: "4px 9px",
                      width: "24px",
                    }}
                  >
                    {casperOutputData[record?.casper_id]?.technical_grade === '' ? '-' :casperOutputData[record?.casper_id]?.technical_grade}
                  </div>
                </>
              </Col>
              <Col
                className="gutter-row"
                style={{ marginTop: "12px" }}
                span={6}
              >
                <>
                  <div
                    className="voyage-data-header"
                    style={{
                      background: "white",
                      marginLeft: "-1rem",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "16px",
                    }}
                  >
                    GHG Intensity
                  </div>
                  <div
                    className="voyage-data-content"
                    style={{ background: "white", marginLeft: "-1rem" }}
                  >
                    {casperOutputData[record?.casper_id]?.total_ghg || casperOutputData[record?.casper_id]?.total_ghg == 0 ? casperOutputData[record?.casper_id]?.total_ghg.toFixed(3) : '-'} gCO₂/MJ
                  </div>
                </>
              </Col>
              <Col
                className="gutter-row"
                style={{ marginTop: "12px" }}
                span={6}
              >
                <>
                  <div
                    className="voyage-data-header"
                    style={{
                      background: "white",
                      marginLeft: "-1rem",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "16px",
                    }}
                  >
                    Compliance Balance
                  </div>
                  <div
                    className="voyage-data-content"
                    style={{ background: "white", marginLeft: "-1rem" }}
                  >
                    {casperOutputData[record?.casper_id]?.compliance_balance || casperOutputData[record?.casper_id]?.compliance_balance == 0 ? casperOutputData[record?.casper_id]?.compliance_balance.toFixed(3) : '-'} gCO₂eq
                  </div>
                </>
              </Col>
              <Col
                className="gutter-row"
                style={{ marginTop: "12px" }}
                span={6}
              >
                <>
                  <div
                    className="voyage-data-header"
                    style={{
                      background: "white",
                      marginLeft: "-1rem",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "16px",
                    }}
                  >
                    FEUM Penalty
                  </div>
                  <div
                    className="voyage-data-content"
                    style={{ background: "white", marginLeft: "-1rem" }}
                  >
                    €{casperOutputData[record?.casper_id]?.penalty || casperOutputData[record?.casper_id]?.penalty == 0 ? casperOutputData[record?.casper_id]?.penalty.toFixed(3) : '-'}
                  </div>
                </>
              </Col>
              <Col
                className="gutter-row"
                style={{ marginTop: "12px" }}
                span={6}
              >
                <>
                  <div
                    className="voyage-data-header"
                    style={{
                      background: "white",
                      marginLeft: "-1rem",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "16px",
                    }}
                  >
                    EUA
                  </div>
                  <div
                    className="voyage-data-content"
                    style={{ background: "white", marginLeft: "-1rem" }}
                  >
                    {casperOutputData[record?.casper_id]?.eua || casperOutputData[record?.casper_id]?.eua == 0 ? casperOutputData[record?.casper_id]?.eua?.toFixed(3) : '-'}
                  </div>
                </>
              </Col>
            </Row>
          )}
        </div>
      )}

      {selectedOption === "Fuel Consumption" ? (
        <>
          <hr></hr>
          <div className="voyage-data-multi" style={{ width: "18vw" }}>
            Alternate Fuels (MT)
            <Row
              style={{ marginLeft: "1px" }}
              gutter={{
                xs: 8,
                sm: 16,
                md: 24,
                lg: 32,
              }}
            >
              {record?.fuel_details.map(
                (fuel, index) =>
                  fuel.fuel_type === "ALTERNATE" && (
                    <Col
                      key={index}
                      className="gutter-row"
                      style={{ marginTop: "12px" }}
                      span={12}
                    >
                      <div
                        className="voyage-data-header"
                        style={{
                          background: "white",
                          marginLeft: "-1rem",
                          fontSize: "10px",
                          fontWeight: "400",
                          lineHeight: "11.4px",
                        }}
                      >
                        {fuel.name}
                      </div>
                      <div
                        className="voyage-data-content"
                        style={{ background: "white" }}
                      >
                        {`${fuel.total_fuel}`}
                      </div>
                    </Col>
                  )
              )}
            </Row>
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default VoyageData;
